import { Select } from "antd";
import styled from "styled-components";

export const UnifiedGridWrapper = styled.div`
  width: 100%;
  min-height: calc(100dvh - 220px);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const UnifiedGrid = styled.div`
  display: grid;
  gap: 16px;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(220px, min(100%, 280px)));

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, minmax(230px, min(100%, 280px)));
  }

  @media (min-width: 960px) {
    grid-template-columns: repeat(3, minmax(230px, min(100%, 280px)));
  }

  @media (min-width: 1280px) {
    grid-template-columns: repeat(5, minmax(230px, min(100%, 280px)));
  }

  @media (min-width: 1500px) {
    grid-template-columns: repeat(6, minmax(230px, min(100%, 280px)));
  }

  @media (min-width: 1800px) {
    grid-template-columns: repeat(7, minmax(230px, min(100%, 280px)));
  }

  @media (min-width: 2100px) {
    grid-template-columns: repeat(8, minmax(230px, min(100%, 280px)));
  }
`;

export const LoadMoreWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const EmptyState = styled.div`
  width: 100%;
  text-align: center;
  padding: 64px 16px;
  color: #8c8c8c;
  font-size: 16px;
`;

export const IconWrapper = styled.div<{ borderColor?: string; backgroundColor?: string }>`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  border: ${({ borderColor }) => borderColor && `1px solid ${borderColor}`};
  background: ${({ backgroundColor }) => backgroundColor && `${backgroundColor}`};
`;

export const KanbanContainer = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  height: calc(100dvh - 120px);
  overflow-x: auto;
`;

export const KanbanColumn = styled.div<{ $borderColor?: string; $collapsed?: boolean }>`
  flex: ${({ $collapsed }) => $collapsed ? '0 0 48px' : '1'};
  min-width: ${({ $collapsed }) => $collapsed ? '48px' : '280px'};
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  border: 1px solid ${({ $borderColor }) => $borderColor || '#e5e7eb'};
  overflow: hidden;
  transition: all 0.3s ease;
`;

export const KanbanColumnHeader = styled.div<{ $backgroundColor?: string; $collapsed?: boolean }>`
  padding: ${({ $collapsed }) => $collapsed ? '16px 8px' : '12px 16px'};
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  border-bottom: ${({ $collapsed }) => $collapsed ? 'none' : '1px solid #e5e7eb'};
  background: ${({ $backgroundColor }) => $backgroundColor || '#fff'};
  ${({ $collapsed }) => $collapsed && `
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
    white-space: nowrap;

    & > span {
      writing-mode: vertical-rl;
      text-orientation: mixed;
      transform: rotate(180deg);
      margin-left: 0;
    }

    & > ${KanbanColumnCount} {
      margin-left: 0;
      margin-top: auto;
    }
  `}
`;

export const KanbanColumnCount = styled.span<{ $color?: string }>`
  margin-left: auto;
  font-size: 12px;
  font-weight: 500;
  color: ${({ $color }) => $color || '#8c8c8c'};
`;

export const KanbanColumnBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
`;

export const SubHeaderWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const DeleteReasonSelect = styled(Select)`
  min-width: 265px;
`;
